import React from 'react';

const UdemyRecentReviews = ({ instructorCourses }) => {
  // Simular reseñas para los cursos del instructor
  const reviews = [
    { id: 1, courseId: 1, rating: 5, comment: "Excelente curso, muy completo y bien explicado.", student: "Juan Pérez", date: "Hace 3 días" },
    { id: 2, courseId: 1, rating: 4, comment: "Buen contenido pero podría mejorar en los ejemplos prácticos.", student: "María Gómez", date: "Hace 1 semana" },
    { id: 3, courseId: 2, rating: 5, comment: "Figma es increíble, y este curso lo explica todo.", student: "Pedro Ruiz", date: "Hace 2 días" }
  ];

  // Filtrar reseñas que correspondan a los cursos del instructor
  const instructorCourseIds = instructorCourses.map(course => course.id);
  const filteredReviews = reviews.filter(review => instructorCourseIds.includes(review.courseId));

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Valoraciones recientes</h2>
        <a href="#" className="text-purple-600 hover:text-purple-800 text-sm font-medium">Ver todas</a>
      </div>
      <div className="space-y-4">
        {filteredReviews.length > 0 ? (
          filteredReviews.map(review => (
            <div key={review.id} className="border-b border-gray-200 pb-4 last:border-0 last:pb-0">
              <div className="flex items-center mb-2">
                <div className="flex items-center mr-2">
                  {[...Array(5)].map((_, i) => (
                    <svg
                      key={i}
                      className={`w-4 h-4 ${i < review.rating ? 'text-yellow-400' : 'text-gray-300'}`}
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <span className="text-sm text-gray-500">{review.student}</span>
                <span className="mx-2 text-gray-300">•</span>
                <span className="text-sm text-gray-500">{review.date}</span>
              </div>
              <p className="text-gray-700">{review.comment}</p>
            </div>
          ))
        ) : (
          <p className="text-gray-600">No hay valoraciones recientes para tus cursos.</p>
        )}
      </div>
    </div>
  );
};

export default UdemyRecentReviews;